import React from "react";
import { useNavigate } from "react-router-dom";
import TransitionWrapper from "../../../../components/common/transition-wrapper";
import FadeInWrapper from "../../../../components/common/fade-in-wrapper";
import IMG1 from "./intro1.png";
import IMG2 from "./intro2.png";
import Header from "../../../../components/common/header";

const LiveOrderIntro = () => {
  const navigate = useNavigate();
  const onClickButton = () => {
    navigate(`/boss/live-order/select-from-menu`);
  };

  return (
    <div className="h-full bg-white min-h-screen">
      <Header title="실시간 판매" showBackButton />
      <FadeInWrapper className="flex flex-col h-full p-4">
        <div className="space-y-12">
          <div className="flex items-start">
            <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              1
            </div>
            <h1 className="text-3xl font-bold">메뉴를 선택해서 올려주세요!</h1>
          </div>
          <div className="flex justify-center items-center h-48">
            <img
              src={IMG1}
              alt="실시간판매"
              className="max-h-56 bg-gray-200 rounded-2xl"
            />
          </div>
          <div className="flex items-start">
            <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              2
            </div>
            <h1 className="text-3xl font-bold">손님에게 알림이 갑니다!</h1>
          </div>
          <div className="flex justify-center items-center h-48">
            <img
              src={IMG2}
              alt="실시간판매"
              className="max-h-56 bg-gray-200 rounded-2xl"
            />
          </div>
          <p className="text-gray-500 text-md">
            마감할인 시작 최초 1회에만 알림이 갑니다.
            <br />
            여러번 올려도 괜찮아요~!
          </p>
        </div>

        <div className="flex flex-col items-center justify-center mt-8">
          <div className="flex flex-col items-center justify-center mb-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                className="mr-2"
                onChange={(e) => {
                  if (e.target.checked) {
                    localStorage.setItem("hideIntro", "true");
                  } else {
                    localStorage.removeItem("hideIntro");
                  }
                }}
              />
              <span className="text-blue-500 text-xl font-bold">
                더 이상 보지 않기
              </span>
            </label>
          </div>

          <TransitionWrapper
            scale={0.9}
            opacity={0.8}
            onClick={onClickButton}
            className="w-full h-[60px] flex items-center justify-center bg-[#1562fc] rounded-3xl border"
          >
            <div className="text-center flex items-center space-x-1">
              <span className="text-white font-bold leading-snug">
                메뉴선택하기
              </span>
            </div>
          </TransitionWrapper>
        </div>
      </FadeInWrapper>
    </div>
  );
};

export default LiveOrderIntro;
